import type { HTMLAttributes, PropsWithChildren } from 'react';

import { cn } from '../../lib/utils';

type FieldLabelProps = PropsWithChildren<{
    className?: string;
    dataTestid?: string;
    htmlAttributes?: HTMLAttributes<HTMLParagraphElement>;
}>;

export const FieldError = ({ children, className, dataTestid, htmlAttributes }: FieldLabelProps) => (
    <p
        data-component-name='FieldError'
        className={cn('mt-1 mb-2 text-xs font-medium text-red-500', className)}
        data-testid={dataTestid}
        {...htmlAttributes}
    >
        {children}
    </p>
);
